import styled from "styled-components"

const StyledSVG = styled.svg`
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 16px;
    height: 19px;
  }
`

const SvgComponent = () => {
  const w = 22
  const h = 22
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      data-name="tiktok icon"
      width={w}
      height={h}
      viewBox="0 0 16 18.658"
      aria-labelledby="mcd-tiktok-title mcd-tiktok-desc"
    >
      <title id="mcd-tiktok-title">
        לינק שמעביר את המשתמש לטיקטוק של מקדונלדס
      </title>
      <desc id="mcd-tiktok-desc">אייקון של טיקטוק של מקדונלדס</desc>
      <path
        data-name="tiktok icon"
        d="M12.237 0c.308 2.648 1.786 4.226 4.355 4.394v2.978a6.806 6.806 0 0 1-4.31-1.259v5.57c0 7.075-7.713 9.286-10.814 4.215-1.993-3.263-.772-8.99 5.62-9.219v3.14a9.249 9.249 0 0 0-1.483.364 2.531 2.531 0 0 0-2 2.972c.431 3.045 6.017 3.946 5.553-2V.006h3.084z"
        transform="translate(-.591)"
        fill="evenodd"
      />
    </StyledSVG>
  )
}

export default SvgComponent
